import { render, staticRenderFns } from "./ReleaseForm.vue?vue&type=template&id=b35bb102&"
import script from "./ReleaseForm.vue?vue&type=script&lang=js&"
export * from "./ReleaseForm.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseForm.vue?vue&type=style&index=0&id=b35bb102&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports